import styled from 'styled-components';

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const LoadingContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  min-width: 200px;
`;

export const LoadingText = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #333;
  text-align: center;
`;

export const ApplePayContainer = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const ApplePayButton = styled.button`
  display: inline-block;
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: plain;
  -apple-pay-button-style: black;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: black;
  background-image: -webkit-named-image(apple-pay-logo-white);
  background-size: 15%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    opacity: 0.6;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  text-align: center;
`;

export const UnavailableMessage = styled.div`
  display:none;
  color: #fff;
  font-size: 0.875rem;
  text-align: center;
  font-style: italic;
  margin: 1rem 0;
`;
